import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { isString, logErrorAndRunFail } from '../../utils';

export function getStorageSync(key: string) {
  if (!isString(key)) {
    return logErrorAndRunFail(
      APINames.Native.GET_STORAGE_SYNC,
      {},
      `parameter error:key should be string instead of ${typeof key}.`
    );
  }
  return MacleJSBridge.invokeSync(APINames.Native.GET_STORAGE_SYNC, { key });
}
